import http from '../../http'

const getCustomDashboardReportURLPowerbi = (token, name) => http.get(`/integrations/powerbi/reports/custom-dashboard?token=${token}&name=${name}`)

const getCustomReportURLPowerbi = (token, name) => http.get(`/integrations/powerbi/reports/custom-report?token=${token}&name=${name}`)

export {
  getCustomDashboardReportURLPowerbi,
  getCustomReportURLPowerbi
}